/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Last_ModifiedInputs */

const en_explorer_info_property_last_modified = /** @type {(inputs: Explorer_Info_Property_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Modified`)
};

const fr_explorer_info_property_last_modified = /** @type {(inputs: Explorer_Info_Property_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derniere modification`)
};

const de_explorer_info_property_last_modified = /** @type {(inputs: Explorer_Info_Property_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Änderung`)
};

const it_explorer_info_property_last_modified = /** @type {(inputs: Explorer_Info_Property_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima modifica`)
};

const ru_explorer_info_property_last_modified = /** @type {(inputs: Explorer_Info_Property_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последнее изменение`)
};

const es_explorer_info_property_last_modified = /** @type {(inputs: Explorer_Info_Property_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última modificación`)
};

const zh_cn2_explorer_info_property_last_modified = /** @type {(inputs: Explorer_Info_Property_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后修改日期`)
};

const ja_explorer_info_property_last_modified = /** @type {(inputs: Explorer_Info_Property_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新日`)
};

const hi_explorer_info_property_last_modified = /** @type {(inputs: Explorer_Info_Property_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम बार संशोधित`)
};

const pt_pt2_explorer_info_property_last_modified = /** @type {(inputs: Explorer_Info_Property_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última modificação`)
};

/**
* | output |
* | --- |
* | "Last Modified" |
*
* @param {Explorer_Info_Property_Last_ModifiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_last_modified = /** @type {((inputs?: Explorer_Info_Property_Last_ModifiedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Last_ModifiedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_last_modified(inputs)
	if (locale === "de") return de_explorer_info_property_last_modified(inputs)
	if (locale === "it") return it_explorer_info_property_last_modified(inputs)
	if (locale === "ru") return ru_explorer_info_property_last_modified(inputs)
	if (locale === "es") return es_explorer_info_property_last_modified(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_last_modified(inputs)
	if (locale === "ja") return ja_explorer_info_property_last_modified(inputs)
	if (locale === "hi") return hi_explorer_info_property_last_modified(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_last_modified(inputs)
	return en_explorer_info_property_last_modified(inputs)
});